import React from 'react';
import usePageTitle from '../hooks/usePageTitle';

const About = () => {
    usePageTitle("About | Dinara Fariz");

    return (
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-12 text-gray-800">

            <div className="flex flex-col md:flex-row gap-6 md:gap-14 items-start">

                {/* Фото */}
                <div className="w-full md:w-1/2 flex justify-center">
                    <img
                        src="/DinaraAbout.jpg"
                        alt="Dinara Fariz"
                        className="w-full max-w-[380px] md:max-w-none md:w-full object-cover
                                    border border-gray-200 shadow-sm"
                    />
                </div>

                {/* Текст */}
                <div className="w-full md:w-1/2 max-w-[560px] text-left space-y-5 md:space-y-6">

                    <h2 className="text-2xl md:text-3xl font-light uppercase tracking-[0.2em]">
                        About
                    </h2>

                    <p className="leading-relaxed text-base tracking-wide">
                        After graduating from Beijing Central Academy of Arts (CAFA) in 2013 I have worked as
                        an interior designer in Beijing and Shanghai for several years, spent a semester
                        in Paris in 2016-2017, learning the language and culture. Afterwards I  came back home
                        to Kazakhstan, Almaty, continued working as an interior designer for two years, later
                        switched to floral event decoration for a while.
                    </p>

                    <p className="leading-relaxed text-base tracking-wide">
                        Over time, I came to realize that my true calling was in art in its purest form.
                    </p>

                    <p className="leading-relaxed text-base tracking-wide">
                        Since 2020, I have fully dedicated myself to artistic practice and teaching.
                        After co-founding an art studio and successfully selling the business in 2024,
                        I now work as a full time artist.
                    </p>

                    <p className="leading-relaxed text-base tracking-wide">
                        Today, I collaborate with designers, create commissioned works,
                        and develop my own original artwork. I am open to creative collaborations
                        and new artistic projects around the world.
                    </p>

                    {/* Доп блок (делает страницу “дороже”) */}
                    <div className="pt-4 text-sm uppercase tracking-[0.2em] text-gray-500 space-y-1">
                        <p>Based in Kazakhstan</p>
                        <p>Available for commissions</p>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default About;